module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAALRJREFUeAHt2EEKgCAARUHt/ncuT+DbGcK4fUQx/I2N4RAgQIAAAQIECBAgQIDAaYH5rrN76Vxn1+v53bM3tOeGj/zzGwGFPiBAIRDZggCFQGQLCiCZAAECBAgQIECAAAECBM4L+Ccd5m7zgEIgsgUBCoHIFgQoBCJbUADJBAgQIECAAAECBAgQIHBewD/pMHebBxQCkS0IUAhEtiBAIRDZggJIJkCAAAECBAgQIECAAIHzAh8rCBgincsF6AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/list.png
// module id = DbsC
// module chunks = 1